import { GET_REQUEST } from '@helpers/request.js';
import { API_HOST_NAME, API_SALES_PORTAL_SALE_REPORT_PATH } from '../../env.js';

const SALES_REPORT_ROOT = API_HOST_NAME + API_SALES_PORTAL_SALE_REPORT_PATH;
const structurePaths = {
  datetime: SALES_REPORT_ROOT + '/common/datetime',
  agentIsLeafNode: SALES_REPORT_ROOT + '/common/agent-is-leaf-node',
  team: {
    common: SALES_REPORT_ROOT + '/team',
  },
  individual: {
    common: SALES_REPORT_ROOT + '/individual',
  },
  summary: {
    common: SALES_REPORT_ROOT + '/summary',
  },
  pieChart: {
    common: SALES_REPORT_ROOT + '/pie-chart-data',
  },
  policies: {
    common: SALES_REPORT_ROOT + '/policies',
  },
};
export const getSalesReportDatetimeListService = ({ timeType }) =>
  GET_REQUEST(structurePaths.datetime, { timeType });

export const getAgentIsLeafNodeService = ({ timeType, timeValue, code }) =>
  GET_REQUEST(structurePaths.agentIsLeafNode, { timeType, timeValue, code });

export const getSalesReportGroupListService = ({
  timeType,
  timeValue,
  code,
  codeType,
  reportType,
  page,
  size,
  sort,
  channel = 'agencyNous',
  isTopNode,
  isIndirectHierarchy,
}) => {
  const requestObject = {
    timeType,
    timeValue,
    code,
    codeType,
    reportType,
    isTopNode: isTopNode ? 1 : 0,
    isIndirectHierarchy: isIndirectHierarchy ? 1 : 0,
    page,
    size,
    sort,
  };
  if (['agencyNous', 'dls', 'ps', 'acb', 'tpb'].includes(channel)) {
    return GET_REQUEST(structurePaths.team.common, requestObject);
  }
  return null;
};

export const getSalesReportIndividualListService = ({
  timeType,
  timeValue,
  code,
  codeType,
  reportType,
  page,
  size,
  sort,
  channel = 'agencyNous',
}) => {
  const requestObject = {
    timeType,
    timeValue,
    code,
    codeType,
    reportType,
    page,
    size,
    sort,
  };
  if (['agencyNous', 'dls', 'ps', 'acb', 'tpb'].includes(channel)) {
    return GET_REQUEST(structurePaths.individual.common, requestObject);
  }
  return null;
};

export const getSalesReportSummaryService = ({
  timeType,
  timeValue,
  code,
  codeType,
  channel,
  isTopNode,
  isIndirectHierarchy,
}) => {
  const requestObject = {
    timeType,
    timeValue,
    code,
    codeType,
    isTopNode: isTopNode ? 1 : 0,
    isIndirectHierarchy: isIndirectHierarchy ? 1 : 0,
  };
  if (['agencyNous', 'dls', 'ps', 'acb', 'tpb'].includes(channel)) {
    return GET_REQUEST(structurePaths.summary.common, requestObject);
  }
  return null;
};

export const getSalesReportPieChartService = ({
  timeType,
  timeValue,
  code,
  codeType,
  reportType,
  channel,
  isTopNode,
  isIndirectHierarchy,
  isAcbLeaderOrLbs,
}) => {
  const requestObject = {
    timeType,
    timeValue,
    code,
    codeType,
    reportType,
    isTopNode: isTopNode ? 1 : 0,
    isIndirectHierarchy: isIndirectHierarchy ? 1 : 0,
    isAcbLeaderOrLbs,
  };
  if (['agencyNous', 'dls', 'ps', 'acb', 'tpb'].includes(channel)) {
    return GET_REQUEST(structurePaths.pieChart.common, requestObject);
  }
  return null;
};

export const getSalesReportPolicyService = ({
  timeType,
  timeValue,
  code,
  codeType,
  reportType,
  page,
  size,
  policySort,
  policyNumber,
  appNumber,
  policyStatusCode,
  submittedDateFrom,
  submittedDateTo,
  appReceivedDateFrom,
  appReceivedDateTo,
  issuedDateFrom,
  issuedDateTo,
  channel = 'agencyNous',
  isIndirectHierarchy,
  serviceAgentInfo,
}) => {
  const requestObject = {
    timeType,
    timeValue,
    code,
    codeType,
    reportType,
    page,
    size,
    sort: policySort,
    policyNumber,
    appNumber,
    policyStatusCode,
    submittedDateFrom,
    submittedDateTo,
    appReceivedDateFrom,
    appReceivedDateTo,
    issuedDateFrom,
    issuedDateTo,
    isIndirectHierarchy: isIndirectHierarchy ? 1 : 0,
    serviceAgentInfo,
  };
  if (['agencyNous', 'dls', 'ps', 'acb', 'tpb'].includes(channel)) {
    return GET_REQUEST(structurePaths.policies.common, requestObject);
  }
  return null;
};
